import { findTarget } from '@shared/lib';

/** Пример, разрезанный вокруг изучаемого слова: `pre` + `word` + `post`. Как ищется
 *  слово — см. findTarget. Не нашли — пример без выделения. */
export function splitExample(example: string, word: string) {
  const target = findTarget(example, word);
  if (!target) return { pre: example, word: '', post: '' };
  const [start, end] = target;
  return { pre: example.slice(0, start), word: example.slice(start, end), post: example.slice(end) };
}
